"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

var _classnames2 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isWebkit = !!window.chrome || !!window.safari;
/**
 * @class
 */

var Input =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Input, _PureComponent);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setHeaderRef", function (element) {
      _this.headerRef = element;
    });

    _defineProperty(_assertThisInitialized(_this), "handleRealChange", function (event) {
      var onChange = _this.props.onChange;

      if ((0, _spauiUtils.isFunction)(onChange) && event && event.target) {
        var nextValue = onChange(event, event.target.value || ''); // 某些场景下，中文输入后，内部的 state 已经修改了，
        // 但是外层的 value 一直是同一个值（相当于是强制指定用户哪些值不能输入），
        // 导致没法触发 componentWillReceiveProps 函数，不能同步外层的 value

        if ((0, _spauiUtils.isString)(nextValue) || (0, _spauiUtils.isNumber)(nextValue)) {
          _this.setState({
            value: nextValue
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      var _this$props = _this.props,
          value = _this$props.value,
          onKeyPress = _this$props.onKeyPress,
          _this$props$inputProp = _this$props.inputProps,
          inputProps = _this$props$inputProp === void 0 ? {} : _this$props$inputProp;

      if (inputProps && (0, _spauiUtils.isFunction)(inputProps.onKeyPress)) {
        inputProps.onKeyPress(event);
      }

      if ((0, _spauiUtils.isFunction)(onKeyPress)) {
        onKeyPress(event, value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickSearchIcon", function (event) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onClickSearchIcon = _this$props2.onClickSearchIcon,
          _this$props2$IconProp = _this$props2.IconProps,
          IconProps = _this$props2$IconProp === void 0 ? {} : _this$props2$IconProp;

      if ((0, _spauiUtils.isFunction)(onClickSearchIcon)) {
        onClickSearchIcon(event, value);
      }

      if (IconProps && (0, _spauiUtils.isFunction)(IconProps.onClick)) {
        IconProps.onClick(event, value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCommonComponsition", function (e) {
      var _this$props$inputProp2 = _this.props.inputProps,
          inputProps = _this$props$inputProp2 === void 0 ? {} : _this$props$inputProp2;
      var _inputProps$useCompon = inputProps.useComponsition,
          useComponsition = _inputProps$useCompon === void 0 ? true : _inputProps$useCompon;

      if (useComponsition) {
        if (e.type === 'compositionend') {
          // composition is end
          _this.isOnComposition = false; // fixed for Chrome v53+ and detect all Chrome
          // https://chromium.googlesource.com/chromium/src/
          // +/afce9d93e76f2ff81baaa088a4ea25f67d1a76b3%5E%21/

          if (e.target instanceof HTMLInputElement && !_this.isOnComposition && isWebkit) {
            // fire onChange
            _this.handleRealChange(e);
          }
        } else {
          // in composition
          _this.isOnComposition = true;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCompositionStart", function (event) {
      var _this$props$inputProp3 = _this.props.inputProps,
          inputProps = _this$props$inputProp3 === void 0 ? {} : _this$props$inputProp3;
      var onCompositionStart = inputProps.onCompositionStart;

      _this.handleCommonComponsition(event);

      if ((0, _spauiUtils.isFunction)(onCompositionStart)) {
        onCompositionStart(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCompositionUpdate", function (event) {
      var _this$props$inputProp4 = _this.props.inputProps,
          inputProps = _this$props$inputProp4 === void 0 ? {} : _this$props$inputProp4;
      var onCompositionUpdate = inputProps.onCompositionUpdate;

      _this.handleCommonComponsition(event);

      if ((0, _spauiUtils.isFunction)(onCompositionUpdate)) {
        onCompositionUpdate(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCompositionEnd", function (event) {
      var _this$props$inputProp5 = _this.props.inputProps,
          inputProps = _this$props$inputProp5 === void 0 ? {} : _this$props$inputProp5;
      var onCompositionEnd = inputProps.onCompositionEnd;

      _this.handleCommonComponsition(event);

      if ((0, _spauiUtils.isFunction)(onCompositionEnd)) {
        onCompositionEnd(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _this$props$inputProp6 = _this.props.inputProps,
          inputProps = _this$props$inputProp6 === void 0 ? {} : _this$props$inputProp6;
      var _inputProps$useCompon2 = inputProps.useComponsition,
          useComponsition = _inputProps$useCompon2 === void 0 ? true : _inputProps$useCompon2;

      if (useComponsition) {
        // only when onComposition===false to fire onChange
        if (event.target instanceof HTMLInputElement && !_this.isOnComposition) {
          _this.handleRealChange(event);
        } else {
          _this.handleTempChange(event);
        }
      } else {
        _this.handleRealChange(event);
      }
    });

    var _value = props.value || typeof props.value === 'number' ? props.value : '';

    _this.state = {
      value: _value
    };
    _this.suffixRef = null;
    _this.headerRef = null; // 中文输入是否结束了的标记

    _this.isOnComposition = false;
    return _this;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setInputPrefixAndSuffix();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var value = nextProps.value || typeof nextProps.value === 'number' ? nextProps.value : '';
      this.setState({
        value: value
      });
      this.isOnComposition = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.suffixRef = null;
      this.headerRef = null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setInputPrefixAndSuffix();
    }
  }, {
    key: "handleTempChange",
    value: function handleTempChange(event) {
      this.setState({
        value: event.target.value || ''
      });
    }
  }, {
    key: "setInputPrefixAndSuffix",
    value: function setInputPrefixAndSuffix() {
      var autoSuffixWidth = this.props.autoSuffixWidth;
      var suffixSpace = parseInt(this.props.suffixSpace, 10) || 0;
      var suffixRect = {};

      if (autoSuffixWidth && this.suffixRef && this.headerRef) {
        suffixRect = this.suffixRef.getBoundingClientRect();

        if (suffixRect.width > 0) {
          this.headerRef.style.setProperty('--autocomplete-suffix-width', "".concat(parseInt(suffixRect.width + suffixSpace, 10), "px"));
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          name = _this$props3.name,
          placeholder = _this$props3.placeholder,
          disabled = _this$props3.disabled,
          _this$props3$MoreDeta = _this$props3.MoreDetailComponent,
          MoreDetailComponent = _this$props3$MoreDeta === void 0 ? null : _this$props3$MoreDeta,
          htmlRef = _this$props3.htmlRef,
          onClear = _this$props3.onClear,
          clear = _this$props3.clear,
          onClick = _this$props3.onClick,
          _this$props3$classNam = _this$props3.classNameMap,
          classNameMap = _this$props3$classNam === void 0 ? {} : _this$props3$classNam,
          _this$props3$inputPro = _this$props3.inputProps,
          inputProps = _this$props3$inputPro === void 0 ? {} : _this$props3$inputPro,
          _this$props3$IconProp = _this$props3.IconProps,
          IconProps = _this$props3$IconProp === void 0 ? {} : _this$props3$IconProp,
          SearchIconComponent = _this$props3.SearchIconComponent,
          suffix = _this$props3.suffix;
      var value = this.state.value;
      var moreDetailComponentInstance = null;

      if ((0, _spauiUtils.isReactNode)(MoreDetailComponent)) {
        moreDetailComponentInstance = MoreDetailComponent;
      } else {
        moreDetailComponentInstance = _react["default"].createElement(MoreDetailComponent, {
          name: name,
          placeholder: placeholder,
          value: value,
          disabled: disabled,
          clear: clear,
          onClear: onClear
        });
      } // 搜索图标组件


      var IconComponent = null;

      if (typeof SearchIconComponent !== 'undefined') {
        if ((0, _spauiUtils.isReactNode)(SearchIconComponent)) {
          IconComponent = SearchIconComponent;
        } else {
          IconComponent = _react["default"].createElement(SearchIconComponent, this.props);
        }
      } else {
        IconComponent = _react["default"].createElement(_spauiIcon["default"], _extends({}, IconProps, {
          type: "viewer",
          onClick: this.handleClickSearchIcon
        }));
      }

      return _react["default"].createElement("div", {
        className: (0, _classnames2["default"])(classNameMap.AutoCompleteHeadClassName, {
          'has-suffix': suffix
        }),
        onClick: onClick,
        ref: this.setHeaderRef
      }, IconComponent, _react["default"].createElement("input", _extends({}, inputProps, {
        className: (0, _classnames2["default"])('spaui-input', _defineProperty({}, inputProps.className, inputProps.className)),
        name: name,
        value: value,
        placeholder: placeholder,
        disabled: disabled,
        onCompositionStart: this.handleCompositionStart,
        onCompositionUpdate: this.handleCompositionUpdate,
        onCompositionEnd: this.handleCompositionEnd,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        ref: htmlRef
      })), suffix ? _react["default"].createElement("div", {
        className: "spaui-input-suffix",
        ref: function ref(el) {
          _this2.suffixRef = el;
        }
      }, suffix) : null, value && !disabled && clear ? _react["default"].createElement("div", {
        className: "spaui-input-clear",
        role: "button",
        onClick: onClear
      }, _react["default"].createElement("svg", {
        viewBox: "0 0 16 16",
        width: "16px",
        height: "16px"
      }, _react["default"].createElement("circle", {
        fill: "currentColor",
        fillRule: "evenodd",
        cx: "8",
        cy: "8",
        r: "8"
      }), _react["default"].createElement("path", {
        d: "M5.333 5.333l5.334 5.334M10.667 5.333l-5.334 5.334",
        stroke: "#FFF",
        strokeLinecap: "square"
      }))) : null, _react["default"].createElement("span", {
        className: classNameMap.AutoCompleteMoreDetailClassName
      }, moreDetailComponentInstance));
    }
  }]);

  return Input;
}(_react.PureComponent);

var _default = Input;
exports["default"] = _default;